/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function FileIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M28 33c.5 0 1-.437 1-1V14h-5c-1.125 0-2-.875-2-2V7H12c-.562 0-1 .5-1 1v24c0 .563.438 1 1 1zM8 8c0-2.187 1.75-4 4-4h10.313c1.062 0 2.062.438 2.812 1.188l5.688 5.687c.75.75 1.187 1.75 1.187 2.813V32c0 2.25-1.812 4-4 4H12c-2.25 0-4-1.75-4-4z"/>}
        </IconWrapper>);
}
